<span class="attachment-tag">{{ text }}</span>
